export enum DEV_TOOLS_SECTION_ID {
  ACCOUNT_DETAILS = 'accountDetails',
  ACCOUNT_DETAILS_LYRA_ID = 'accountDetailsLyraId',
  ACCOUNT_DETAILS_BASIC_INFO = 'accountDetailsBasicInfo',
  ACCOUNT_DETAILS_DEPENDENTS = 'accountDetailsDependents',
  SEARCH_FOR_CARE = 'searchForCare',
  SEARCH_FOR_CARE_USER = 'searchForCareUser',
  SEARCH_FOR_CARE_TRIAGE = 'searchForCareTriage',
  SEARCH_FOR_CARE_OTHER = 'searchForCareOther',
  THEMING = 'theming',
  THEMING_THEME_TOGGLE = 'themingThemeToggle',
  FEATURE_FLAGS = 'featureFlags',
  FEATURE_FLAGS_ENABLED = 'featureFlagsEnabled',
  FEATURE_FLAGS_DISABLED = 'featureFlagsDisabled',
  FEATURE_FLAGS_COMPLEX = 'featureFlagsComplex',
  QUICK_NAVIGATION = 'quickNavigation',
  QUICK_NAVIGATION_SEARCH_FOR_CARE = 'quickNavigationSearchForCare',
  QUICK_NAVIGATION_MICROSITES = 'quickNavigationMicrosites',
  QUICK_NAVIGATION_WELLNESS_TOOLKITS = 'quickNavigationWellnessToolkits',
  QUICK_NAVIGATION_CENTER_FOR_EXCELLENCE_TOOLKITS = 'centerForExcellenceToolkits',
  QUICK_NAVIGATION_OTHER = 'quickNavigationOther',
  HPI_ELIGIBILITY = 'hpiEligibility',
  HPI_ELIGIBILITY_PROGRAM_COVERAGE = 'hpiEligibilityProgramCoverage',
  MIXPANEL = 'mixpanel',
  MIXPANEL_DEBUG = 'mixpanelDebug',
  MIXPANEL_EVENT_HISTORY = 'mixpanelEventHistory',
  RELEASE_UUID = 'releaseUuid',
  TRANSLATIONS = 'translations',
  AUTHENTICATION = 'authentication',
  PERSIST_STORE = 'persistStore',
  DEBUG_TOOLS = 'debugTools',
  DEBUG_TOOLS_UNIVERSAL_SEARCH = 'debugToolsUniversalSearch',
  DEBUG_TOOLS_UNIVERSAL_SEARCH_AUTO_SEARCH = 'debugToolsUniversalSearchAutoSearch',
  DEBUG_TOOLS_UNIVERSAL_SEARCH_SHOW_DEBUG = 'debugToolsUniversalSearchShowDebug',
}
